import { FETCH_CONTENT_REQUEST, FETCH_CONTENT_SUCCESS, FETCH_CONTENT_ERROR } from '../constants/ActionTypes';

const initialState = {
    loading: false,
    error: false,
};

export default function content(state = initialState, action) {
    switch (action.type) {
        case FETCH_CONTENT_REQUEST:
            return {
                ...state,
                [action.componentKey]: {
                    loading: true,
                    error: false,
                },
            };

        case FETCH_CONTENT_SUCCESS:
            return {
                ...state,
                [action.componentKey]: {
                    response: {
                        body: action.payload,
                        headers: action.headers,
                        status: action.status,
                        path: action.uid,
                    },
                    error: false,
                    loading: false,
                },
            };

        case FETCH_CONTENT_ERROR:
            return {
                ...state,
                [action.componentKey]: {
                    response: {
                        body: action.body,
                        headers: action.headers,
                        status: action.status,
                        path: action.uid,
                    },
                    error: true,
                    loading: false,
                },
            };

        default:
            return state;
    }
}
